export const useAssistantMessages = () => {
    const getDefaultMessages = () => {
        return [
            {
                role: 'assistant',
                content: "<p>Welcome to the Agenda Assistant (beta)! I help you build a personalized INBOUND agenda, taking into account your favorited sessions. Don't like my recommendations? Just let me know and I'll suggest new ones. You can ask about programming, share your preferences, and tell me if you want breaks. To begin, simply share your thoughts in the chat. Note: I can recommend sessions and help with your agenda, but I can't save your seat for capacity controlled sessions.</p><p>For questions about logistics, tickets, hotels, or other INBOUND details, please contact the <a href=\"https://www.inbound.com/onsitesupport\" target=\"_blank\">HelpBot.</a></p>",
            }
        ];
    };

    const getIdleMessages = () => {
        return [
            "Lining everything up behind the scenes...",
            "Decoding your digital aura and connecting it to just the right sessions...",
            "Syncing with the cosmic processing grid...",
            "Passing your preferences through the fiber optic forest...",
            "Mapping your vibes to sessions that impress your future self...",
            "Conversing with the cloud...",
            "Aligning your agenda's front end chakras...",
            "Making sure the details are just right...",
            "Arranging all the time slots like puzzle pieces...",
            "Wrapping your agenda in a layer of curated intention...",
            "Consulting the schedule sages for inspiration...",
            "Tuning the agenda algorithm for maximum serendipity...",
            "Gathering session stardust for your perfect day...",
            "Polishing your personalized recommendations...",
            "Harmonizing your interests with the event universe...",
            "Filtering out the noise to find your ideal sessions...",
            "Mixing creativity with code for your agenda...",
            "Charting a course through the session galaxy...",
            "Translating your preferences into action...",
            "Orchestrating a symphony of sessions just for you...",
            "Spinning up the agenda engines...",
            "Scouting the schedule for hidden gems...",
            "Infusing your agenda with a spark of innovation...",
            "Matching your energy to the event flow...",
            "Curating a timeline that fits your style...",
            "Blending your favorites into the perfect mix...",
            "Surveying the session landscape for opportunities...",
            "Connecting the dots between your interests and the schedule...",
            "Running a vibe check on all available sessions...",
            "Optimizing your day for discovery and delight...",
            "Piecing together your agenda masterpiece...",
            "Consulting the digital oracle for session wisdom...",
            "Fine-tuning your schedule for balance and excitement...",
            "Mapping out moments that matter most to you...",
            "Synchronizing your preferences with the event pulse..."
        ];
    };

    const getErrorMessage = (error) => {
        const errorMessages = {
            network: 'It seems I cannot connect to the assistant service. Please try again later.',
            streaming: 'Error processing response. Please try again.',
            agenda: 'Failed to build agenda. Please try again later.',
            default: `Error: ${error.message || 'An unexpected error occurred'}`,
            response: 'It looks like your last request was cancelled, or had an error. What would you like to do next?',
            debug: 'Here are your extracted preferences and session data. Is there anything specific you\'d like to know about your preferences?',
        };
        return errorMessages[error.type] || errorMessages.default;
    };

    const getSystemMessages = () => {
        return {
            loading: {
                initial: 'Loading session details...',
                agenda: 'Building your personalized agenda...',
                sessions: 'Fetching session data...',
            },
            progress: {
                analyzing: 'Analyzing your preferences...',
                ranking: 'Ranking sessions based on your interests...',
                scheduling: 'Creating your optimized schedule...',
            },
            empty: {
                noMessages: 'No messages yet. Start the conversation!',
                noAgenda: 'No agenda built yet. Click "Build My Agenda" to get started!',
            }
        };
    };
    
    const getAgendaCompleteMessage = () => {
        return "Your personalized INBOUND 2025 agenda is ready! I've included any sessions that you've already added to My Favorites that are relevant to your interests and any sessions that you've already added to My Saved Seats. Please favorite any sessions you'd like to keep, and I'm happy to keep recommending more sessions to fill the gaps! You can add any your sessions to My Favorites and My Saved Seats by clicking the Heart or Chair icons.";
    };
    
    const getPersonalizeMoreMessage = () => {
        return "Tell me more about you! What are you interested in? What are you hoping to get out of INBOUND this year? Are there specific speakers you like? The more you tell me, the better my recommendations will get.";
    };
    
    const getSchedulePreferencesMessage = () => {
        return "Tell me how you'd like to structure your day! Do you need specific breaks for lunch, or do you have a meeting you have to attend? I can take these gaps in your availability into account when I'm building your agenda.";
    };

    return {
        getDefaultMessages,
        getErrorMessage,
        getSystemMessages,
        getAgendaCompleteMessage,
        getPersonalizeMoreMessage,
        getSchedulePreferencesMessage,
        getIdleMessages
    };
};